import React from "react";
import { useSelector } from "react-redux";
import { Toolbar as RhombusToolbar, Button } from "rhombus-react";
import { selectedPreviewData } from "selectors/Selected";
import { SEARCH_DEBOUNCE, TIA_DOMAIN, TYPES } from "utils/constants";
import BulkDeletePreviewsButton from "widgets/toolbars/BulkDeletePreviewsButton";
import BulkExtendPreviewsButton from "widgets/toolbars/BulkExtendPreviewsButton";
import BulkPermanentPreviewsButton from "widgets/toolbars/BulkPermanentPreviewsButtons";
import SelectCount from "widgets/toolbars/SelectCount";

export default function Toolbar({ searchValue, isLoading, onSearch }) {
	const { libraryId, isLibraryLoaded, selectedPreviews } = useSelector(state => ({
			libraryId: state.libraryProperties.id,
			isLibraryLoaded: state.libraryProperties.isLoaded,
			selectedPreviews: selectedPreviewData(state),
		}))
		, mockupLink = `${TIA_DOMAIN}/mockup/${libraryId}`
		, isRowSelected = (selectedPreviews.length > 0)
		, areAllPreviewsNotShared = selectedPreviews.every(preview => preview.status === "not_shared")
		;

	let bulkActionButtons = null;
	if (isRowSelected) {
		bulkActionButtons = (
			<>
				<div className="toolbar-divider" />
				<div className="action-button-side flex-center">
					<SelectCount key="selected" type={TYPES.PREVIEWS} label="Previews" />
					<BulkExtendPreviewsButton previews={selectedPreviews} disabled={areAllPreviewsNotShared} />
					<BulkPermanentPreviewsButton previews={selectedPreviews} disabled={areAllPreviewsNotShared} />
					<BulkDeletePreviewsButton previews={selectedPreviews} />
				</div>
			</>
		);
	}

	return(
		<RhombusToolbar
			className="creative-search"
			search
			searchValue={searchValue}
			searchDebounce={SEARCH_DEBOUNCE}
			onSearch={onSearch}
		>
			<div className="button-side">
				<Button
					icon="addCircleSolid"
					style="block"
					theme="blue"
					isLink
					newTab
					to={mockupLink}
					disabled={!isLibraryLoaded}
				>
					Create Mockup
				</Button>
				{bulkActionButtons}
			</div>
		</RhombusToolbar>
	);
}

Toolbar.displayName = "PreviewsToolbar";
